import React from 'react';
import { LabelActionGuide } from '../Common/ShareWithOrg';

function SaveCargoLabel(props) {
    const {
        value = "",
        onChange = () => { },
        onKeyDown,
        placeholder = "Enter Cargo label",
        label,
        guidanceTitle,
        guidance,
        error = "",
    } = props;

    return (
        <div className="w-full py-1">
            {guidance && <LabelActionGuide title={guidanceTitle}>{guidance}</LabelActionGuide>}
            <label className="block text-xs font-medium text-slate-700">
                {label && <span className="mb-1 block">{label}</span>}
                <input
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    aria-invalid={Boolean(error)}
                    className={`w-full h-8 px-3 text-xs text-slate-800 border rounded-none outline-none focus:border-blue-600 transition-colors ${error ? 'border-rose-500' : 'border-slate-300'}`}
                    autoFocus
                />
            </label>
            {error && <div className="mt-1 text-xs text-rose-600" role="alert">{error}</div>}
        </div>
    );
}

export default SaveCargoLabel;
